/** 
 * @file       HistoryHeader.css
 * @author     Kevin Yu <kevin@distributive.network>
 *
 * @date       March 2024
 *
 *             Style for the HistoryHeade component
 */
 
.history-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: max-content;
  width: 100%;
  padding: 0 5px;
  gap: 5px;
  bottom: -1.5px;
  position: relative;
}

.history-header-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.history-header-title span:nth-child(2) {
  font-weight: normal;
  font-size: 1rem;
}

.history-header h1 {
  word-break: break-all;
}

.history-header-balance {
  display: flex;
  gap: 10px;
  align-items: center;
}

.history-header label {
  color: var(--content-hue-dark);
}

.history-header button.dcc {
  display: flex;
  align-items: center;
  align-items: top;
  justify-content: center;
  color: var(--primary-hue-main);
  padding: 0;
  font-weight: bold;
  font-size: 1.125rem;
}

#history-header-dcc {
  min-width: 13px;
  width: 13px;
  height: 14px;
  position: relative;
}

.history-header-line {
  background: var(--content-hue-main);
  height: 1px;
  width: 100%;
  margin: 2px 0 20px 0;
}
